import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { sendPasswordResetEmail } from "firebase/auth";

const SecuritySettings = () => {
  const { currentUser } = useAuth();
  const [message, setMessage] = useState("");

  const handlePasswordReset = async () => {
    try {
      if (!currentUser || !currentUser.email) return;
      await sendPasswordResetEmail(currentUser.auth, currentUser.email);
      setMessage("✅ Password reset email sent.");
    } catch (error) {
      console.error("Reset error:", error);
      setMessage("❌ Failed to send password reset email.");
    }
  };

  return (
    <div className="space-y-4 text-sm">
      <h2 className="text-lg font-semibold mb-2">Security Settings</h2>

      <div className="bg-gray-100 p-4 rounded shadow-sm">
        <h3 className="font-medium mb-1">Password</h3>
        <p className="text-xs text-gray-600 mb-2">Reset your account password via email.</p>
        <button
          onClick={handlePasswordReset}
          className="px-4 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
        >
          Send Password Reset Email
        </button>
      </div>

      {message && (
        <p className={`text-xs ${message.startsWith("✅") ? "text-green-600" : "text-red-600"}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default SecuritySettings;
